let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l5ytR")).then(() => parcelRequire('3xzAj'));